const NewsTicker = ({ pc, messages }) => {
  const defaultItems = [
    { text: "Welcome to the station! Enjoy the music", link: null },
    { text: "Request your favorite songs in the Request tab", link: null },
    { text: "Sign in to join the Live Chat", link: null },
    { text: "Share this station with your friends!", link: null },
  ];

  const items = (messages && messages.length > 0)
    ? messages.filter(m => m && m.trim()).map(m => ({ text: m, link: null }))
    : defaultItems;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 flex items-center h-8 overflow-hidden" data-testid="news-ticker"
      style={{ background: "#0a0a0a", borderTop: "1px solid #27272a" }}>
      <span className="flex-shrink-0 px-2 py-0.5 mx-2 rounded text-[10px] font-bold text-white uppercase tracking-wider"
        style={{ background: pc || "#8B5CF6" }}>NEWS</span>
      <div className="flex-1 overflow-hidden relative">
        <div className="ticker-scroll flex items-center gap-8 whitespace-nowrap text-sm" style={{ color: "#A1A1AA" }}>
          {items.concat(items).map((item, i) => (
            <span key={i} className="flex items-center gap-2">
              <span className="w-1 h-1 rounded-full" style={{ background: pc }} />
              {item.link ? (
                <a href={item.link} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">{item.text}</a>
              ) : item.text}
            </span>
          ))}
        </div>
      </div>
      <style>{`
        .ticker-scroll { animation: tickerScroll 30s linear infinite; }
        @keyframes tickerScroll { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
      `}</style>
    </div>
  );
};

export default NewsTicker;
